var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import { Grid, Typography } from '@mui/material';
import { FormikTextField } from './atoms/TextField';
import PageSubmitButton from './molecules/PageSubmitButton';
import { camelize } from '../utils/camelize';
import { FormikFileField } from './atoms/FileField';
import { format, addDays } from 'date-fns';
import { FormikSelectField } from './atoms/SelectField';
import FormikDatePicker from './atoms/FormikDatePicker';
import { PaymentTermValues } from '../constants/offerListValues';
import OfferListUploadConfirmDialogContent from './atoms/OfferListUploadConfirmDialogContent';
import { useConfirm } from '../hooks/confirmationHook';
import RoasterCountryCheckboxGroup from './molecules/RoasterCountryCheckboxGroup';
var Form = styled.form(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 30px 0;\n"], ["\n  margin: 30px 0;\n"])));
var RightSideWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-align: right;\n"], ["\n  text-align: right;\n"])));
var CaptionWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
var CsvName = styled.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-left: 20px;\n  vertical-align: -webkit-baseline-middle;\n"], ["\n  margin-left: 20px;\n  vertical-align: -webkit-baseline-middle;\n"])));
var toFormikValue = function () {
    return {
        payment_term: 'reserved',
        published_date: format(addDays(new Date(), 14), 'yyyy-MM-dd'),
        publish_days: 14,
        sample_delivery_date: format(new Date(), 'yyyy-MM-dd'),
    };
};
var REQUIRED_FIELDS = [
    'payment_term',
    'published_date',
    'publish_days',
    'sample_delivery_date',
];
var OfferListUploadForm = function (_a) {
    var onSubmit = _a.onSubmit, loading = _a.loading;
    var t = useTranslation().t;
    var confirm = useConfirm();
    var _b = React.useState([]), publishedCountryIds = _b[0], setPublishedCountryIds = _b[1];
    var handleRoasterCountriesLoaded = React.useCallback(function (countries) {
        setPublishedCountryIds(countries.map(function (country) { return country.id; }));
    }, []);
    var paymentTermItems = React.useMemo(function () {
        return PaymentTermValues.map(function (term) { return ({
            value: term,
            text: t("params.offerList.paymentTerms.".concat(term)),
        }); });
    }, [t]);
    var handleSubmit = React.useCallback(function (values) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            confirm('Confirm upload', React.createElement(OfferListUploadConfirmDialogContent, null), function () { return __awaiter(void 0, void 0, void 0, function () {
                var formData;
                return __generator(this, function (_a) {
                    formData = new FormData();
                    Object.entries(values).forEach(function (_a) {
                        var key = _a[0], value = _a[1];
                        if (key === 'file' && value instanceof File) {
                            formData.append("offer_list[".concat(key, "]"), value);
                        }
                        else {
                            formData.append("offer_list[".concat(key, "]"), "".concat(value));
                        }
                    });
                    publishedCountryIds.forEach(function (id) {
                        formData.append('offer_list[published_country_ids][]', id);
                    });
                    onSubmit(formData);
                    return [2 /*return*/];
                });
            }); });
            return [2 /*return*/];
        });
    }); }, [onSubmit, confirm, publishedCountryIds]);
    var validate = React.useCallback(function (values) {
        var errors = {};
        var maxSampleDeliveryDate = addDays(new Date(values.published_date), -14);
        if (maxSampleDeliveryDate < new Date(values.sample_delivery_date)) {
            errors['sample_delivery_date'] = t('pages.offerUpload.sampleDeliveryDateMemo');
        }
        REQUIRED_FIELDS.forEach(function (field) {
            if (!values[field] || values[field] === '') {
                errors[field] = t('errors.isRequired', {
                    field: t("params.offerList.".concat(camelize(field))),
                });
            }
        });
        return errors;
    }, [t]);
    var formik = useFormik({
        initialValues: toFormikValue(),
        onSubmit: handleSubmit,
        validate: validate,
        validateOnMount: true,
        validateOnChange: true,
        enableReinitialize: true,
    });
    return (React.createElement(Form, { onSubmit: formik.handleSubmit },
        React.createElement(Grid, { container: true, spacing: 3 },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(FormikSelectField, { fullWidth: true, name: "payment_term", label: t('params.offerList.paymentTerm'), items: paymentTermItems, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(FormikDatePicker, { fullWidth: true, name: "published_date", label: t('params.offerList.publishedDate'), required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(FormikTextField, { type: "number", label: t('params.offerList.publishDays'), name: "publish_days", fullWidth: true, required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(FormikDatePicker, { fullWidth: true, name: "sample_delivery_date", label: t('params.offerList.sampleDeliveryDate'), required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(RoasterCountryCheckboxGroup, { label: t('params.offerList.publishedCountries'), name: "published_country_ids", value: publishedCountryIds, onLoaded: handleRoasterCountriesLoaded, onChange: setPublishedCountryIds })),
            React.createElement(Grid, { item: true, xs: 8 },
                React.createElement(FormikFileField, { name: "file", accept: ".csv", label: t('buttons.chooseFile'), formik: formik }),
                formik.values.file && React.createElement(CsvName, null, formik.values.file.name)),
            React.createElement(Grid, { item: true, xs: 4 },
                React.createElement(RightSideWrapper, null,
                    React.createElement("a", { href: "/example_offer.csv", target: "_blank", rel: "noopener noreferrer", download: true }, t('pages.offerUpload.download'))))),
        React.createElement(PageSubmitButton, { disabled: !formik.isValid || loading || !formik.values.file }, t('buttons.upload')),
        React.createElement(CaptionWrapper, null,
            React.createElement(Typography, { variant: "caption" }, t('pages.offerUpload.uploadMemo')))));
};
export default OfferListUploadForm;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
